import T from './actionTypes';

export const getUser = (newUser) => {
  return {
    type: T.GET_USER,
    newUser,
  };
};



/** WEBPACK FOOTER **
 ** ./src/app/redux/actions/index.js
 **/